export const enum FieldName {
  EmailAddress = 'emailAddress',
  Password = 'password',
  RememberMe = 'rememberMe',
}
